var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 39H26v-2.576l.498-.289C28.112 35.2 29 33.732 29 32c0-2.757-2.243-5-5-5s-5 2.243-5 5c0 1.732.888 3.2 2.501 4.135l.499.289V39H8V12c0-2.206 1.794-4 4-4h27v2H12c-1.103 0-2 .897-2 2v25h9.287C17.818 35.715 17 33.954 17 32c0-3.86 3.14-7 7-7s7 3.14 7 7c0 1.954-.818 3.715-2.287 5H39v2",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 72H12c-2.206 0-4-1.794-4-4V41h2v27c0 1.103.897 2 2 2h25v-9.287C35.715 62.182 33.954 63 32 63c-3.86 0-7-3.14-7-7s3.14-7 7-7c1.954 0 3.715.818 5 2.287V41h2v13h-2.576l-.289-.499C35.2 51.888 33.732 51 32 51c-2.757 0-5 2.243-5 5s2.243 5 5 5c1.732 0 3.2-.888 4.135-2.501l.289-.499H39v14",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 72H41v-2h27c1.103 0 2-.897 2-2V43h-9.21c1.436 1.222 2.21 2.95 2.21 5 0 3.86-3.14 7-7 7s-7-3.14-7-7c0-2.05.774-3.778 2.21-5H41v-2h13v2.607l-.54.281C51.828 44.735 51 46.119 51 48c0 2.757 2.243 5 5 5s5-2.243 5-5c0-1.881-.828-3.265-2.46-4.112l-.54-.281V41h14v27c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 39h-2V12c0-1.103-.897-2-2-2H43v9.287C44.285 17.818 46.046 17 48 17c3.86 0 7 3.14 7 7s-3.14 7-7 7c-1.954 0-3.715-.818-5-2.287V39h-2V26h2.576l.289.499C44.8 28.112 46.268 29 48 29c2.757 0 5-2.243 5-5s-2.243-5-5-5c-1.732 0-3.2.888-4.135 2.501l-.289.499H41V8h27c2.206 0 4 1.794 4 4v27M37 14h2v-2h-2zM33 14h2v-2h-2zM29 14h2v-2h-2zM49 68h2v-2h-2zM45 68h2v-2h-2zM41 68h2v-2h-2zM12 43h2v-2h-2zM12 47h2v-2h-2zM12 51h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M66 31h2v-2h-2zM66 35h2v-2h-2zM66 39h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationPuzzle;